import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { getLabelsFromExportRequests } from 'services/results'
import { ResultsQueryKeys } from 'services/results/queryKeys'
import type { GetLabelsFromExportRequestsResponse } from 'services/results/types'
import type { ApiErrorResponse } from 'services/types'

export const useGetLabelsFromExportRequests = (
  options?: Omit<UseQueryOptions<GetLabelsFromExportRequestsResponse, ApiErrorResponse>, 'queryKey'>
) => {
  return useQuery<GetLabelsFromExportRequestsResponse, ApiErrorResponse>({
    queryKey: ResultsQueryKeys.LabelsFromExportRequests(),
    queryFn: ({ signal }) => getLabelsFromExportRequests({ signal }),
    ...options
  })
}
